/**
 * @typedef {{ checkAlpha?: boolean; checkUpper?: boolean; checkLower?: boolean; checkDigits?: boolean; checkSymbols?: boolean; }} ParsleyPasswordValidatorRequirement
 */

const currentLocale = mpro.getCurrentLocalesFor(mpro.getCurrentLocale(), 'parsleyjs')[0] || 'en';
const { Parsley } = window;

const validateLetters = (value) => {
	return /[a-z]/i.test(value);
};

const validateDigits = (value) => {
	return /\d/.test(value);
};

const validateSymbols = (value) => {
	return /[!"#$%&'()*+,./:;<=>?@[\\\]^_`{|}~\-]/.test(value);
};

const validateUppercase = (value) => {
	return /[A-Z]/.test(value);
};

const validateLowercase = (value) => {
	return /[a-z]/.test(value);
};

/**
 * @param {string} value
 * @param {ParsleyPasswordValidatorRequirement} requirement
 */
const validate = (value, requirement) => {

	const {
		checkAlpha = true,
		checkLower = true,
		checkUpper = true,
		checkDigits = true,
		checkSymbols = true,
	} = (requirement || {});

	const errors = [];

	if (checkAlpha === true) {
		if (validateLetters(value) === false) {
			errors.push('error_password_letters');
		}
	}
	else {
		if (checkLower === true && validateLowercase(value) === false) {
			errors.push('error_password_lowercase');
		}
		if (checkUpper === true && validateUppercase(value) === false) {
			errors.push('error_password_uppercase');
		}
	}

	if (checkDigits === true && validateDigits(value) === false) {
		errors.push('error_password_digits');
	}

	if (checkSymbols === true && validateSymbols(value) === false) {
		errors.push('error_password_symbols');
	}

	return errors;
};

/**
 * The only password validator to be used.
 */
Parsley.addValidator('password', {

	requirementType: 'object',

	/**
	 * @param {string} value
	 * @param {ParsleyPasswordValidatorRequirement} requirement
	 */
	validateString: (value, requirement, parsleyInstance) => {

		// const { $element } = parsleyInstance;
		const validationResult = validate(value, requirement);

		// No errors
		if (validationResult.length === 0) {
			return true;
		}

		// Let parsley return the custom validator message
		if (Parsley.instanceHasCustomValidatorMessage(parsleyInstance, 'password')) {
			return false;
		}

		// Return the default message
		return $.Deferred().reject(validationResult.map(error => mpro.langvar(error)).join('<br>'));
	},

	// Let other validators run first (like the count chars validator)
	// priority: 32,

	// Note: can only set one message per locale
	messages: {
		[currentLocale]: '',
	},
});

export {};